// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as OrgRouteImport } from './routes/org'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminCommunicationsRouteImport } from './routes/admin/communications'
import { Route as CallbackIndexRouteImport } from './routes/callback.index'
import { Route as CallbackSignoutRouteImport } from './routes/callback.signout'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsGuideRouteImport } from './routes/docs/guide'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as OrgIndexRouteImport } from './routes/org/index'
import { Route as OrgOrgRouteImport } from './routes/org/$org'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsTabRouteImport } from './routes/settings.$tab'
import { Route as AdminCommunicationsIndexRouteImport } from './routes/admin/communications/index'
import { Route as AdminCommunicationsIdRouteImport } from './routes/admin/communications/$id'
import { Route as AdminCommunicationsNewRouteImport } from './routes/admin/communications/new'
import { Route as AdminOrgRouteImport } from './routes/admin/org.'
import { Route as AdminOrgsIndexRouteImport } from './routes/admin/orgs.index'
import { Route as DocsGuideIndexRouteImport } from './routes/docs/guide.index'
import { Route as GoOrgKeysRouteImport } from './routes/go/org/keys'
import { Route as GoOrgOverviewRouteImport } from './routes/go/org/overview'
import { Route as GoOrgPeopleRouteImport } from './routes/go/org/people'
import { Route as InvitationAcceptInvitationIdRouteImport } from './routes/invitation.accept.$invitationId'
import { Route as McpAuthErrorRouteImport } from './routes/mcp/auth/error'
import { Route as McpAuthSignedOutRouteImport } from './routes/mcp/auth/signed-out'
import { Route as OrgOrgIndexRouteImport } from './routes/org/$org.index'
import { Route as OrgOrgDocsRouteImport } from './routes/org/$org.docs'
import { Route as OrgOrgKeysRouteImport } from './routes/org/$org.keys'
import { Route as OrgOrgPeopleRouteImport } from './routes/org/$org.people'
import { Route as AdminOrgOrgIndexRouteImport } from './routes/admin/org.$org.index'
import { Route as AdminOrgOrgCommunicationsRouteImport } from './routes/admin/org.$org.communications'
import { Route as AdminOrgOrgKeysRouteImport } from './routes/admin/org.$org.keys'
import { Route as AdminOrgOrgPeopleRouteImport } from './routes/admin/org.$org.people'
import { Route as AdminOrgOrgQuotasRouteImport } from './routes/admin/org.$org.quotas'
import { Route as DocsGuideSlugIndexRouteImport } from './routes/docs/guide.$slug.index'
import { Route as DocsGuideSlugEditRouteImport } from './routes/docs/guide.$slug.edit'
import { Route as DocsGuideSlugPreviewRouteImport } from './routes/docs/guide.$slug.preview'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const OrgRoute = OrgRouteImport.update({
            id: '/org',path: '/org',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminCommunicationsRoute = AdminCommunicationsRouteImport.update({
            id: '/communications',path: '/communications',getParentRoute: () => AdminRoute
          })
const CallbackIndexRoute = CallbackIndexRouteImport.update({
            id: '/callback/',path: '/callback/',getParentRoute: () => rootRouteImport
          })
const CallbackSignoutRoute = CallbackSignoutRouteImport.update({
            id: '/callback/signout',path: '/callback/signout',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRoute
          })
const DocsGuideRoute = DocsGuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => DocsRoute
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LegalRoute
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LegalRoute
          })
const OrgIndexRoute = OrgIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgRoute
          })
const OrgOrgRoute = OrgOrgRouteImport.update({
            id: '/$org',path: '/$org',getParentRoute: () => OrgRoute
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => rootRouteImport
          })
const SettingsTabRoute = SettingsTabRouteImport.update({
            id: '/settings/$tab',path: '/settings/$tab',getParentRoute: () => rootRouteImport
          })
const AdminCommunicationsIndexRoute = AdminCommunicationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCommunicationsRoute
          })
const AdminCommunicationsIdRoute = AdminCommunicationsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminCommunicationsRoute
          })
const AdminCommunicationsNewRoute = AdminCommunicationsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminCommunicationsRoute
          })
const AdminOrgRoute = AdminOrgRouteImport.update({
            id: '/org/',path: '/org/',getParentRoute: () => AdminRoute
          })
const AdminOrgsIndexRoute = AdminOrgsIndexRouteImport.update({
            id: '/orgs/',path: '/orgs/',getParentRoute: () => AdminRoute
          })
const DocsGuideIndexRoute = DocsGuideIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsGuideRoute
          })
const GoOrgKeysRoute = GoOrgKeysRouteImport.update({
            id: '/go/org/keys',path: '/go/org/keys',getParentRoute: () => rootRouteImport
          })
const GoOrgOverviewRoute = GoOrgOverviewRouteImport.update({
            id: '/go/org/overview',path: '/go/org/overview',getParentRoute: () => rootRouteImport
          })
const GoOrgPeopleRoute = GoOrgPeopleRouteImport.update({
            id: '/go/org/people',path: '/go/org/people',getParentRoute: () => rootRouteImport
          })
const InvitationAcceptInvitationIdRoute = InvitationAcceptInvitationIdRouteImport.update({
            id: '/invitation/accept/$invitationId',path: '/invitation/accept/$invitationId',getParentRoute: () => rootRouteImport
          })
const McpAuthErrorRoute = McpAuthErrorRouteImport.update({
            id: '/mcp/auth/error',path: '/mcp/auth/error',getParentRoute: () => rootRouteImport
          })
const McpAuthSignedOutRoute = McpAuthSignedOutRouteImport.update({
            id: '/mcp/auth/signed-out',path: '/mcp/auth/signed-out',getParentRoute: () => rootRouteImport
          })
const OrgOrgIndexRoute = OrgOrgIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgOrgRoute
          })
const OrgOrgDocsRoute = OrgOrgDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => OrgOrgRoute
          })
const OrgOrgKeysRoute = OrgOrgKeysRouteImport.update({
            id: '/keys',path: '/keys',getParentRoute: () => OrgOrgRoute
          })
const OrgOrgPeopleRoute = OrgOrgPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => OrgOrgRoute
          })
const AdminOrgOrgIndexRoute = AdminOrgOrgIndexRouteImport.update({
            id: '/org/$org/',path: '/org/$org/',getParentRoute: () => AdminRoute
          })
const AdminOrgOrgCommunicationsRoute = AdminOrgOrgCommunicationsRouteImport.update({
            id: '/org/$org/communications',path: '/org/$org/communications',getParentRoute: () => AdminRoute
          })
const AdminOrgOrgKeysRoute = AdminOrgOrgKeysRouteImport.update({
            id: '/org/$org/keys',path: '/org/$org/keys',getParentRoute: () => AdminRoute
          })
const AdminOrgOrgPeopleRoute = AdminOrgOrgPeopleRouteImport.update({
            id: '/org/$org/people',path: '/org/$org/people',getParentRoute: () => AdminRoute
          })
const AdminOrgOrgQuotasRoute = AdminOrgOrgQuotasRouteImport.update({
            id: '/org/$org/quotas',path: '/org/$org/quotas',getParentRoute: () => AdminRoute
          })
const DocsGuideSlugIndexRoute = DocsGuideSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => DocsGuideRoute
          })
const DocsGuideSlugEditRoute = DocsGuideSlugEditRouteImport.update({
            id: '/$slug/edit',path: '/$slug/edit',getParentRoute: () => DocsGuideRoute
          })
const DocsGuideSlugPreviewRoute = DocsGuideSlugPreviewRouteImport.update({
            id: '/$slug/preview',path: '/$slug/preview',getParentRoute: () => DocsGuideRoute
          })





const AdminCommunicationsRouteChildren = {
  AdminCommunicationsIdRoute: AdminCommunicationsIdRoute,AdminCommunicationsNewRoute: AdminCommunicationsNewRoute,AdminCommunicationsIndexRoute: AdminCommunicationsIndexRoute
}

const AdminCommunicationsRouteWithChildren = AdminCommunicationsRoute._addFileChildren(AdminCommunicationsRouteChildren)



const AdminRouteChildren = {
  AdminCommunicationsRoute: AdminCommunicationsRouteWithChildren,AdminIndexRoute: AdminIndexRoute,AdminOrgRoute: AdminOrgRoute,AdminOrgsIndexRoute: AdminOrgsIndexRoute,AdminOrgOrgCommunicationsRoute: AdminOrgOrgCommunicationsRoute,AdminOrgOrgKeysRoute: AdminOrgOrgKeysRoute,AdminOrgOrgPeopleRoute: AdminOrgOrgPeopleRoute,AdminOrgOrgQuotasRoute: AdminOrgOrgQuotasRoute,AdminOrgOrgIndexRoute: AdminOrgOrgIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const DocsGuideRouteChildren = {
  DocsGuideIndexRoute: DocsGuideIndexRoute,DocsGuideSlugEditRoute: DocsGuideSlugEditRoute,DocsGuideSlugPreviewRoute: DocsGuideSlugPreviewRoute,DocsGuideSlugIndexRoute: DocsGuideSlugIndexRoute
}

const DocsGuideRouteWithChildren = DocsGuideRoute._addFileChildren(DocsGuideRouteChildren)



const DocsRouteChildren = {
  DocsGuideRoute: DocsGuideRouteWithChildren,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)




const LegalRouteChildren = {
  LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)




const OrgOrgRouteChildren = {
  OrgOrgDocsRoute: OrgOrgDocsRoute,OrgOrgKeysRoute: OrgOrgKeysRoute,OrgOrgPeopleRoute: OrgOrgPeopleRoute,OrgOrgIndexRoute: OrgOrgIndexRoute
}

const OrgOrgRouteWithChildren = OrgOrgRoute._addFileChildren(OrgOrgRouteChildren)



const OrgRouteChildren = {
  OrgOrgRoute: OrgOrgRouteWithChildren,OrgIndexRoute: OrgIndexRoute
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,DocsRoute: DocsRouteWithChildren,LegalRoute: LegalRouteWithChildren,OrgRoute: OrgRouteWithChildren,CallbackSignoutRoute: CallbackSignoutRoute,SettingsTabRoute: SettingsTabRoute,CallbackIndexRoute: CallbackIndexRoute,SettingsIndexRoute: SettingsIndexRoute,GoOrgKeysRoute: GoOrgKeysRoute,GoOrgOverviewRoute: GoOrgOverviewRoute,GoOrgPeopleRoute: GoOrgPeopleRoute,InvitationAcceptInvitationIdRoute: InvitationAcceptInvitationIdRoute,McpAuthErrorRoute: McpAuthErrorRoute,McpAuthSignedOutRoute: McpAuthSignedOutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)